import React from "react"
import "./src/styles/global.css"
import AppErrorBoundary from "./src/components/AppErrorBoundary"
import { wrapWithRenderProfiler } from "./src/utils/profileRender"

export const wrapRootElement = ({ element }) =>
  React.createElement(AppErrorBoundary, null, wrapWithRenderProfiler(element))
